import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const getParticularsurveyAPI = createAsyncThunk(
  "auth/survey/getPaticular",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.get(
        apiRoutes.surveyAction(id, 1)
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" };
const getparticularDetailssurveySlice = createSlice({
  name: "get particular survey",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetgetparticularsurvey: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getParticularsurveyAPI.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getParticularsurveyAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(getParticularsurveyAPI.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetgetparticularsurvey } = getparticularDetailssurveySlice.actions;
export const getparticularDetailssurveyReducer =
  getparticularDetailssurveySlice.reducer;
